export const phoneFormat = (phone?: string | null) =>
  phone?.replace(`+7`, '').replace(/-|_/g, '').replace(/ /g, '');
